import { useContext } from "react"
import classNames from "classnames"

import { ValueView } from "web/components"

import { DataTableContext } from "./DataTable"
import { GroupDisplayValue } from "./helpers"

export default function RowGroupSummary({
  groupKey,
  groupNumber,
  groupValues,
  groupTotals,
  isStickySummary = false,
}) {
  const {
    columns,
    groupColumn,
    secondGroupColumn,
    canSelectRow,
    isCompact,
    hasFrozenColumns,
    showDetails,
    showRowNumbers,
  } = useContext(DataTableContext)

  const groupIsEven = groupNumber % 2 === 0

  const testId = `datatable-group-summary-row-${groupKey}`

  const totalsForGroup = groupTotals.find((group) => group.key === groupKey)

  function getGroupTotalForColumn(column) {
    if (!groupTotals || !totalsForGroup || !column.dataKey) return null
    return (
      totalsForGroup[column.dataKey] ||
      totalsForGroup?.field_values[column.dataKey]
    )
  }

  const sharedCellClasses = classNames("border-b flex max-w-full px-2 py-1", {
    "h-9": isCompact,
    "h-10": !isCompact,
    "font-bold bg-primary-9 border-gray-50": showDetails,
    "border-neutral-9": !showDetails,
    "bg-primary-11": !showDetails && groupIsEven,
    "bg-white": !showDetails && !groupIsEven,
    "text-primary-4": isStickySummary,
  })

  const ordinalClasses = classNames(sharedCellClasses, {
    "sticky left-0": hasFrozenColumns,
  })

  const rowSelectorClasses = classNames(sharedCellClasses, {
    sticky: hasFrozenColumns,
    "left-0": hasFrozenColumns && !showRowNumbers,
    "left-[30px]": hasFrozenColumns && showRowNumbers,
  })

  function notAGroupColumn(column) {
    return (
      column.dataKey !== groupColumn && column.dataKey !== secondGroupColumn
    )
  }

  return (
    <div data-testid={testId} className="contents">
      {showRowNumbers && (
        <div className={ordinalClasses} style={{ width: "30px" }} />
      )}
      {canSelectRow && (
        <div className={rowSelectorClasses} style={{ width: "30px" }} />
      )}
      {columns.map((column, index) => {
        const groupTotal = getGroupTotalForColumn(column)
        const hasGroupTotal = !!groupTotal

        const cellClasses = classNames(sharedCellClasses, {
          sticky: column.freeze,
          "border-r border-r-neutral-7": column.isLastFrozenColumn,
        })

        const cellStyle = { ...column.style, left: column.leftPosition }

        return (
          <div className={cellClasses} style={cellStyle} key={index}>
            {hasGroupTotal && notAGroupColumn(column) && (
              <ValueView
                value={groupTotal}
                fieldPresentation={column.presentation}
                percentValue={groupTotal.percent_value}
              />
            )}

            {column.dataKey === groupColumn && (
              <GroupDisplayValue
                value={groupValues[0]}
                columnLabel={column.label}
              />
            )}
            {column.dataKey === secondGroupColumn && (
              <GroupDisplayValue
                value={groupValues[1]}
                columnLabel={column.label}
              />
            )}
          </div>
        )
      })}
    </div>
  )
}
